import React from 'react'
import {FaEarlybirds} from "react-icons/fa"
import { Navbar, NavItem} from 'react-bootstrap'
const Header = () => {
  return (
   
    <nav class="navbar shadow p-3 ">
  
  
    <span class="navbar-brand mb-1 h1 fw-bolder">  <img src='awl.jpg'/> El Buho  </span>   <NavItem>    Departamentos en villa Carlos Paz</NavItem> 
 

</nav>

  )
}

export default Header